'use strict';

var GithubSlugger = require("github-slugger");

var instance = new GithubSlugger();

function slug(str) {
  instance.reset();
  return instance.slug(str);
}

exports.instance = instance;
exports.slug = slug;
/* instance Not a pure module */



// WEBPACK FOOTER //
// ./src/GithubSlugger.js